import { render } from "./TrainingSelection.vue?vue&type=template&id=7967f215&ts=true"
import script from "./TrainingSelection.vue?vue&type=script&lang=ts"
export * from "./TrainingSelection.vue?vue&type=script&lang=ts"

import "./TrainingSelection.vue?vue&type=style&index=0&id=7967f215&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__